import { HighchartsModule } from '@caslink/common-client/ng-app/highcharts/highcharts.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MonitoringChartComponent } from './monitoring-chart.component';


@NgModule({
    imports: [
        CommonModule,
        HighchartsModule,
    ],
    declarations: [
        MonitoringChartComponent,
    ],
    exports: [
        MonitoringChartComponent,
    ],
})
export class MonitoringChartModule {}
